import React from "react";
import { LayoutContainerBase, BodyBase } from "./style";
import "../layout/layout.css";
import { withSnackbar } from "../../../components/atoms/SpSnackBar";

const LayoutBase = (props) => {
	return (
		<LayoutContainerBase>
			<BodyBase>{props.children}</BodyBase>
		</LayoutContainerBase>
	);
};

export default withSnackbar(LayoutBase);
